<template>
    <div>
        <div class="card mb-3" id="category">
            <div class="card-header headline category">
                <h2 class="text-white d-inline">دسته بندی</h2>
                <button class="btn btn-secondary float-left" data-toggle="modal" data-target="#category-modal"
                        @click="onModalButtonClicked">افزودن دسته بندی
                </button>
            </div>
            <div class="card-body">
                <div class="row">
                    <!--<div class="col-lg-12 mb-3">
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>-->
                    <div class="col-lg-12 mt-5" v-if="categories.length < 1">
                        <h3 class="text-center no-item-alert">دسته بندی ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in categories">
                        <div class="card shadow pt-2 pb-2" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12">
                                    <h5 class="text-center">{{item.name}}</h5>
                                    <small class="text-center">
                                        دسته بندی مادر:
                                        {{ item.parentCategoryName }}
                                    </small>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="categorys.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getcategorys">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loading">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <!--<div v-if="!autoload && categories.length < dataCount" class="col-lg-12 text-center mb-3" @click="getCategories">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>-->
                </div>
            </div>
        </div>
        <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن دسته بندی</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش دسته بندی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row text-center">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان دسته بندی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="categoryName">
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">دسته بندی مادر</span>
                                    </div>
                                    <vs-select
                                            :data="categories"

                                            :mode="'create'"
                                            :header="{multiple: false, label: 'name'}"
                                            @onChange="onCategoryChange"
                                    ></vs-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger" @click="onDeleteClicked">حذف</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'category',
        components: {VsSelect},
        data() {
            return {
                categories: [],
                queryParams: {
                    /*pageSize: 12,
                    pageIndex: 0,
                    name: "",*/
                    companyId: 0
                },
                // category: {
                //     name: "",
                //     companyId: 0,
                //     // id: 0,
                //     // parentCategoryId: 0
                // },
                categoryName: "",
                params: {
                    mode: 'create'
                },
                searchString: "",
                dataCount: 0,
                parentCategoryId: null,
                categoryId: 0,
                autoload: false,
                isSending: false
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            // this.category.companyId = parseInt(localStorage.getItem("companyId"));
            this.queryParams.companyId = parseInt(localStorage.getItem("companyId"));

            this.getCategories();
            // new BaseService('categories', '/getAll').getList(this.queryParams).then(response => {
            //     this.categories = response.data;
            //     // this.dataCount = response.data.count;
            //     $("#loading").hide();
            // }).catch(error => {
            //     // error
            //     Utils.handleErrorWithNotification(error.message, this.$noty);
            // });

            /*if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.categories.length < this.dataCount) {
                        $("#loading").show();
                        this.getCategories();
                    }
                });
            }*/
        },
        methods: {
            getCategories() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('categories', '/getAll').getList(this.queryParams).then(response => {
                    this.categories = response.data;
                    for (let i = 0; i < this.categories.length; i++) {
                        if (this.categories[i].parentCategoryId != null) {
                            for (let j = 0; j < this.categories.length; j++) {
                                if (this.categories[j].id === this.categories[i].parentCategoryId) {
                                    this.categories[i].parentCategoryName = this.categories[j].name;
                                    break;
                                }
                            }
                        }else {
                            this.categories[i].parentCategoryName ="---";
                        }

                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('categories', '/getAll').getList(this.queryParams).then(response => {
                    this.categories = response.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onCardClicked(index) {
                this.params.mode = 'edit';
                // this.category = JSON.parse(JSON.stringify(this.categories[index]));
                // this.category.companyId = parseInt(localStorage.getItem("companyId"));
                this.categoryName = this.categories[index].name;
                this.categoryId = this.categories[index].id;

                $("#category-modal").modal("show");
            },
            onModalButtonClicked() {
                this.params.mode = 'create';
                this.categoryName = "";
                this.parentCategoryId = null;
                // Utils.resetObject(this.category);
                // this.category.companyId = parseInt(localStorage.getItem("companyId"));
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate();
                } else {
                    this.onUpdate();
                }
            },
            onCreate() {
                if(!this.isSending) {
                    this.isSending=true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending=false;
                    }).catch(error => {
                        this.isSending=false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onUpdate() {
                if(!this.isSending) {
                    this.isSending=true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: this.categoryId,
                        parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').update(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت ویرایش شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending=false;
                    }).catch(error => {
                        this.isSending=false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onCategoryChange(e) {
                this.parentCategoryId = e.id;
            },
            onDeleteClicked() {
                if (confirm("آیا از حذف این دسته بندی اطمینان دارید؟")) {
                    new BaseService('categories').delete(this.categoryId).then(response => {
                        this.$noty.warning("با موفقیت حذف شد!");
                        $("#category-modal").modal("hide");
                        this.getCategories();
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });

                }
            },

        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#category-modal").hasClass("show")) {
                $("#category-modal").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>